import React from 'react';
import {
  CAlert,
} from '@coreui/react'

const APIErrorAlert = (props)=> {
  if(props.error!==''){
    return (
      <CAlert color="danger">
        {props.error}
      </CAlert>
    )
  }
  return <p/>
}

export default APIErrorAlert